<a routerLink="{{ url }}" [queryParams]="query" class="hb-entry hb-entry--level2">
  <h2 class="hb-entry-title">{{ tittel }}</h2>

  <div class="hb-entry-description">
    @if (!kpi) {
      <span class="hb-spinner hb-spinner--tekst-justert" role="alert">
        <span class="hb-screenreader-only">{{ " " }}Vennligst vent, siden laster.</span>
      </span>
      <span class="hb-spinner-tekst hb-text--center">{{ " " }}Laster nøkkeltall...</span>
    }

    @if (kpi) {
      <p class="hb-avstand--ingen">{{ kpi.header }}:</p>
      <p class="hb-avstand--ingen hb-text--lg">{{ kpi.value.qText }}</p>
    }
  </div>
</a>
